<app-cancel-open-banking-popin
  (continue)="closeCancelPopin()"
  [isCancelPopinOpen]="isCancelPopinOpen"
>
</app-cancel-open-banking-popin>

<div class="w-full max-w-600px d-flex flex-col justify-center items-center">
    <h2 class="text-center font-20 font-md-24">
      {{ "bank_choice_select" | translate }}
    </h2>

    <div class="notice mt-10">
      <img
      style="width: 27px"
        class="self-center w-78px w-md-100px"
        src="../../../../../assets/images/svg/info_circle.svg"
        alt="info circle"
      />
  
      <div class="ml-6 text-left">
        <strong>{{ "bank_choice_bankWhereIncomeAreDomiciliated" | translate }}</strong>
        <br>
        <span>{{ "bank_choice_onlyIndividualAccount" | translate }}</span>
      </div>
    </div>

  <p class="text-center mt-10">
    {{ "bank_choice_willBeRedirectedToBankLogin" | translate }}
  </p>

  <div
    *ngIf="!isShowingAllBanks"
    class="w-full d-flex flex-col justify-center items-center pt-5 px-0 px-md-3"
  >
    <ul
      class="w-full max-w-350px d-grid grid-cols-3 gap-3 text-center list-none pl-0"
    >
      <li
        (click)="selectBank(bank)"
        *ngFor="let bank of mostPopularBanks"
        class="cursor-pointer"
      >
        <img
          class="w-58px p-4 border-solid border-1 border-lightgray rounded"
          *ngIf="!isTestBankConnector(bank.uid)"
          alt="selected bank logo"
          [src]="bank.logo"
        />
        <img
          class="w-58px p-4 border-solid border-1 border-lightgray rounded"
          *ngIf="isTestBankConnector(bank.uid)"
          alt="test bank connector logo"
          src="/assets/images/test_bank_connector.png"
        />
        <p class="mt-2 font-12 font-md-14">{{ bank.name }}</p>
      </li>
    </ul>

    <div
      (click)="showAllBanks()"
      class="text-primary cursor-pointer pt-5 font-14"
    >
      <span class="picto-add"></span>
      {{ "bank_choice_plus" | translate }}
    </div>
  </div>

  <div *ngIf="isShowingAllBanks" class="form-control w-full max-w-350px pt-5">
    <input
      [(ngModel)]="searchTerm"
      [placeholder]="'bank_choice_search' | translate"
      type="search"
    />
  </div>

  <ul *ngIf="isShowingAllBanks" class="w-full max-w-500px list-none pt-4 px-0">
    <li
      (click)="selectBank(bank)"
      *ngFor="let bank of filteredBanks; index as i"
      class="d-flex justify-between px-2 py-3 border-solid border-0 border-verylightgray cursor-pointer"
      [class.border-b-1]="i < filteredBanks.length - 1"
    >
      <img
        *ngIf="!isTestBankConnector(bank.uid)"
        [src]="bank.logo"
        alt="selected bank logo"
        class="w-30px"
      />
      <img
        *ngIf="isTestBankConnector(bank.uid)"
        src="/assets/images/test_bank_connector.png"
        alt="test bank connector logo"
        class="w-30px"
      />
      <span class="w-full px-3 font-md-16 py-1">{{ bank.name }}</span>
      <!-- FIXME -->
      <span class="font-40 line-height-22 text-lightgray font-medium"
        >&#8250;</span
      >
    </li>
  </ul>
</div>

<button
(click)="openCancelPopin()"
class="btn bg-gray rounded-full px-5 mt-10"
>
{{ "common_cancel" | translate }}
</button>

<span class="text-dimgray mt-2 font-14 font-md-15">
{{ "bank_choice_cancel" | translate }}
</span>